<template>
  <v-card color="sexta" :loading="carregando">
    <v-card-title>
      <v-sheet elevation="0" color="sexta" width="100%" class="my-2 pa-2 c-titulo-op-fase" rounded>
        <v-btn :disabled="boardEditing.state.busy" aria-label="Cancelar configuração" absolute right top fab small class="mt-7 mr-n1" @click="clouseOpFase()">
          <v-icon color="segunda">close</v-icon>
        </v-btn>
        <h3 class="segunda--text font-weight-regular font-weight-bold">
          <v-icon large color="segunda" class="pr-2">settings_suggest</v-icon>CONFIGURAR FASE
        </h3>
        <hr color="segunda" class="mt-3" />
      </v-sheet>
    </v-card-title>
    <v-card-text v-if="!carregando && carregou" :inert="boardEditing.state.busy">
      <v-row>
        <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-5 pb-n5">
          <v-text-field
            class="c-dataCampos-nomeFase mt-4"
            color="segunda"
            outlined
            autofocus
            :rules="[rulesCheckbox.nomeFase]"
            label="NOME DA FASE"
            v-model="dataCampos.nomeFase"
            maxlength="100" counter="100"
            v-on:keyup.enter="addCamposFase()"
            hint="Pressione enter após alterar o nome da fase"
          ></v-text-field>
          <v-switch
            class="c-dataCampos-TextoCurto__opcao"
            label="Adicionar a opção de anexar arquivos ?"
            v-model="dataCampos.anexo"
            @change="desativarFaseBackup($event, 'anexos')"
          ></v-switch>
          <v-expand-transition>
            <v-col v-if="dataCampos.anexo" class="my-0 py-0">
              <v-text-field
                class="c-dataCampos-TextoCurto__titulo"
                autofocus
                :rules="[rulesCheckbox.requiredAnexo]"
                label="Nome do campo"
                v-model="dataCampos.anexoNome"
              ></v-text-field>
              <v-text-field
                dense
                color="segunda"
                label="Observações do campo"
                filled
                v-model="dataCampos.anexoObs"
              ></v-text-field>
            </v-col>
          </v-expand-transition>
          <v-switch
            class="c-dataCampos-TextoCurto__opcao"
            label="Adicionar texto curto ?"
            v-model="dataCampos.textoCurtoOpcao"
            @change="desativarFaseBackup($event, 'textoCurto')"
          ></v-switch>
          <v-expand-transition>
            <v-col v-if="dataCampos.textoCurtoOpcao" class="my-0 py-0">
              <v-text-field
                class="c-dataCampos-TextoCurto__titulo"
                autofocus
                :rules="[rulesCheckbox.requiredTitulo]"
                label="Nome do campo"
                v-model="dataCampos.textoCurtoTitulo"
              ></v-text-field>
              <v-text-field
                dense
                color="segunda"
                label="Observações do campo"
                filled
                v-model="dataCampos.textoCurtoObs"
              ></v-text-field>
            </v-col>
          </v-expand-transition>
          <v-switch
            class="c-dataCampos-Checkbox__opcao"
            label="Adicionar checkboxs ?"
            v-model="dataCampos.checkBoxOpcao"
            @change="desativarFaseBackup($event, 'checkbox')"
          ></v-switch>
          <v-expand-transition>
            <v-col v-if="dataCampos.checkBoxOpcao" class="my-0 py-0">
              <v-expansion-panels inset multiple v-model="painelAberto">
                <v-expansion-panel>
                  <v-expansion-panel-header>Checkbox</v-expansion-panel-header>
                  <v-expansion-panel-content class="c-dataCampos-checkBox">
                    <v-checkbox
                      v-model="dataCampos.checkBoxIsObrigatorio"
                      label="Este campo é obrigatório?"
                      color="segunda"
                    ></v-checkbox>
                    <v-text-field
                      class="c-dataCampos-CheckBox__titulo"
                      autofocus
                      label="Título do campo"
                      :rules="[rulesCheckbox.required]"
                      v-model="dataCampos.checkBoxTitulo"
                    ></v-text-field>
                    <v-text-field
                      dense
                      color="segunda"
                      label="Observações do campo"
                      filled
                      v-model="dataCampos.checkBoxObs"
                    ></v-text-field>
                    <div class="c-dataCampos-CheckBox__campos">
                      <h3 class="mb-3">Adicione as opções</h3>
                      <div
                        class="c-dataCampos-Checkbox__campo"
                        :class="`c-dataCampos-Checkbox__${i}`"
                        v-for="(cpCheckbox, i) in dataCampos.checkboxCampos"
                        :key="i"
                      >
                        <v-text-field
                          v-model="dataCampos.checkboxCampos[i]"
                          clearable
                          :label="'Opção ' + JSON.stringify(i + 1)"
                          :rules="[rulesCheckbox.required]"
                          append-outer-icon="delete_forever"
                          @click:append-outer="deleteOp(i)"
                          @change="addCampo($event, i)"
                        ></v-text-field>
                      </div>
                      <v-icon
                        color="segunda"
                        class="float-right"
                        x-large
                        @click="addOpcaoCheckbox()"
                      >add_circle</v-icon>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-expand-transition>
          <v-switch
            class="c-dataCampos-Radio__opcao"
            label="Adicionar seleção de única opção ?"
            v-model="dataCampos.radioOpcao"
            @change="desativarFaseBackup($event, 'radio')"
          ></v-switch>
          <v-expand-transition>
            <v-col v-if="dataCampos.radioOpcao" class="my-0 py-0">
              <v-expansion-panels inset multiple v-model="painelRadio">
                <v-expansion-panel>
                  <v-expansion-panel-header>Seleção de única opção</v-expansion-panel-header>
                  <v-expansion-panel-content class="c-dataCampos-radio">
                    <v-checkbox
                      v-model="dataCampos.radioObrigatorio"
                      label="Este campo é obrigatório?"
                      color="segunda"
                    ></v-checkbox>
                    <v-text-field
                      class="c-dataCampos-Radio__titulo"
                      autofocus
                      label="Título do campo"
                      :rules="[rulesCheckbox.radioRequired]"
                      v-model="dataCampos.radioTitulo"
                    ></v-text-field>
                    <v-text-field
                      dense
                      color="segunda"
                      label="Observações do campo"
                      filled
                      v-model="dataCampos.radioObs"
                    ></v-text-field>
                    <div class="c-dataCampos-Radio__campos">
                      <h3 class="mb-3">Adicione as opções</h3>
                      <div
                        class="c-dataCampos-Radio__campo"
                        :class="`c-dataCampos-Radio__${idRadio}`"
                        v-for="(cpRadio, idRadio) in dataCampos.radioCampos"
                        :key="idRadio"
                      >
                        <v-text-field
                          v-model="dataCampos.radioCampos[idRadio]"
                          clearable
                          :label="'Opção ' + JSON.stringify(idRadio + 1)"
                          :rules="[rulesCheckbox.radioRequired]"
                          append-outer-icon="delete_forever"
                          @click:append-outer="deleteOpRadio(idRadio)"
                          @change="addCampoRadio($event, idRadio)"
                        ></v-text-field>
                      </div>
                      <v-icon
                        color="segunda"
                        class="float-right"
                        x-large
                        @click="addOpcaoRadio()"
                      >add_circle</v-icon>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-expand-transition>
          <v-switch
            class="c-dataCampos-Checkbox__opcao"
            label="Integrar a Fase com Sistema de Pregão?"
            v-model="dataCampos.integracaoSisPregao"
            @change="desativarIntegracao($event)"
          ></v-switch>
          <v-scroll-y-reverse-transition>
            <v-col v-if="dataCampos.integracaoSisPregao" class="ma-0 pa-0">
              <v-expansion-panels flat inset multiple v-model="painelIntegracao" class="ma-0 pa-0">
                <v-expansion-panel>
                  <v-expansion-panel-content color="sexta">
                    <autenticaPregao
                      :dadosIntegracao="dataCampos.integracao"
                      @getAutenSistPregao="autSistPregao($event)"
                    ></autenticaPregao>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-scroll-y-reverse-transition>
          <v-switch
            class="c-dataCampos-Checkbox__opcao"
            label="Fase de Backup ?"
            hint="Deseja tornar está fase em uma fase de backup?"
            persistent-hint
            v-model="dataCampos.faseBackup"
            @change="ativarFaseBackup($event)"
          ></v-switch>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="nona" class="sexta--text" :disabled="boardEditing.state.busy" @click="clouseOpFase()">CANCELAR</v-btn>
      <v-btn color="primeira" class="sexta--text" :disabled="!podeSalvar" :loading="boardEditing.state.busy" @click="addCamposFase()">SALVAR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import { urlApi, showError } from "@/global";
import autenticaPregao from "./autenticaPregao";

const fields = [
  "checkBoxOpcao", "textoCurtoOpcao", "radioOpcao", "anexo", "faseBackup",
  "checkBoxIsObrigatorio", "radioObrigatorio", "integracaoSisPregao",
  "checkBoxObs", "radioObs", "textoCurtoObs", "anexoObs", "anexoNome",
  "textoCurtoTitulo", "checkBoxTitulo", "radioTitulo", "checkboxCampos", "radioCampos", "integracao"
];
const clone = value => JSON.parse(JSON.stringify(value));
export default {
  name: "opFase",
  inject: ["boardEditing"],
  components: { autenticaPregao },
  props: { idFaseClicada: Number },
  data() {
    return {
      carregando: true, carregou: false, dataCampos: {}, original: {},
      painelAberto: [0], painelRadio: [0], painelIntegracao: [0],
      rulesCheckbox: {
        required: value => !!value || "Valor não pode estar vazio.",
        requiredTitulo: value => !!value || "Valor não pode estar vazio.",
        requiredAnexo: value => !!value || "Valor não pode estar vazio.",
        radioRequired: value => !!value || "Valor não pode estar vazio.",
        nomeFase: value => !!value && !!value.trim() || "Informe o nome da fase."
      }
    };
  },
  computed: {
    podeSalvar() {
      return this.boardEditing.state.active && !this.boardEditing.state.busy && this.carregou && !this.carregando;
    }
  },
  methods: {
    async getFaseOp() {
      if (!this.boardEditing.state.active) return;
      this.carregando = true;
      try {
        const { data } = await axios.get(`${urlApi}/fase/${this.idFaseClicada}`);
        if (this._isDestroyed || !this.boardEditing.state.active) return;
        this.original = clone(data.opcoes);
        this.dataCampos = clone(data.opcoes);
        this.dataCampos.nomeFase = data.nome;
        this.carregou = true;
      } catch (error) { showError(error); }
      finally { this.carregando = false; }
    },
    autSistPregao(value) {
      this.$set(this.dataCampos.integracao, "sistemPregao", clone(value));
    },
    desativarFaseBackup(value) {
      if (value) this.dataCampos.faseBackup = false;
    },
    desativarIntegracao(value) {
      if (value) this.dataCampos.faseBackup = false;
    },
    ativarFaseBackup() {
      if (this.dataCampos.faseBackup) {
        for (const key of ["anexo", "textoCurtoOpcao", "checkBoxOpcao", "radioOpcao", "integracaoSisPregao"]) {
          this.dataCampos[key] = false;
        }
      }
    },
    clouseOpFase() {
      if (!this.boardEditing.state.busy) this.$emit("fecharOpFase");
    },
    async addCamposFase() {
      if (!this.podeSalvar) return;
      const nome = (this.dataCampos.nomeFase || "").trim();
      if (!nome || [...nome].length > 100) return showError("Informe um nome com até 100 caracteres.");
      const opcoes = {};
      fields.forEach(key => {
        if (JSON.stringify(this.original[key]) !== JSON.stringify(this.dataCampos[key])) {
          opcoes[key] = clone(this.dataCampos[key]);
        }
      });
      const patch = { opcoes };
      if (nome !== this.original.nomeFase) patch.nome = nome;
      try {
        const { data } = await this.boardEditing.run(config =>
          axios.patch(`${urlApi}/fase/${this.idFaseClicada}`, patch, config)
        );
        this.$emit("atulizarOpcoesDaFase", data);
        this.$emit("fecharOpFase");
        this.$toasted.global.defaultSuccess({ msg: "Fase atualizada." });
      } catch (error) { showError(error); }
    },
    deleteOp(index) { this.dataCampos.checkboxCampos.splice(index, 1); },
    deleteOpRadio(index) { this.dataCampos.radioCampos.splice(index, 1); },
    addOpcaoCheckbox() { this.dataCampos.checkboxCampos.push(""); },
    addOpcaoRadio() { this.dataCampos.radioCampos.push(""); }
  },
  mounted() { this.getFaseOp(); }
};
</script>

<style>
.c-dataCampos-Checkbox__0 .v-input__append-outer {
  display: none;
}
.c-dataCampos-Radio__0 .v-input__append-outer {
  display: none;
}
</style>
